"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useLanguage = () => {
    const { localization: { selectedLanguage, defaultLanguage } } = (0, react_1.useContext)(context_1.EnrichContext);
    return { selectedLanguage, defaultLanguage };
};
exports.useLanguage = useLanguage;
exports.default = exports.useLanguage;
